import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TeamLogo from '../../components/TeamLogo';
import { mapMappings } from '../../Constants';
import { LiveMatch, currentRound } from '../../services/LiveService';
import LiveBadge from './LiveBadge';
import pageStyles from '../MatchPage2/MatchPage2.module.css';
import styles from './Live.module.css';

const mapLabel = (map: string | null) => (map ? mapMappings.get(map) ?? map.replace(/^de_/, '') : '');

// Card grid of feed maps — the Kampe page's Live tab, and the "just finished" block on its
// Resultater tab. Every card opens the map's scoreboard at /live/:matchId.
const LiveMatchGrid: React.FC<{ matches: LiveMatch[] }> = ({ matches }) => (
    <div className={styles.grid}>
        {matches.map(m => <LiveMatchCard key={m.matchId} match={m} />)}
    </div>
);

const LiveMatchCard: React.FC<{ match: LiveMatch }> = ({ match }) => {
    const { t } = useTranslation('pages');
    const { team1, team2 } = match;
    const foot = [
        mapLabel(match.map),
        // A finished map has no "current" round; say what's still missing instead.
        match.finished ? t('live.awaitingDemo') : t('live.round', { round: currentRound(match) }),
        match.bestOf > 1 ? t('live.series', { a: match.seriesTeam1, b: match.seriesTeam2 }) : null,
    ].filter(Boolean).join(' · ');

    return (
        <Link to={`/live/${match.matchId}`} className={styles.card}>
            <div className={styles.cardTop}>
                <span>{match.divisionName}</span>
                <LiveBadge finished={match.finished} />
            </div>
            <div className={styles.cardBody}>
                <div className={styles.cardTeam}>
                    <TeamLogo logo={team1.logo} name={team1.name} className={styles.cardLogo} />
                    <span className={styles.cardTeamName} title={team1.name}>{team1.name}</span>
                </div>
                <div className={styles.cardScore}>
                    <span className={team1.score > team2.score ? styles.lead : undefined}>{team1.score}</span>
                    <span className={pageStyles.scoreColon}>:</span>
                    <span className={team2.score > team1.score ? styles.lead : undefined}>{team2.score}</span>
                </div>
                <div className={styles.cardTeam}>
                    <TeamLogo logo={team2.logo} name={team2.name} className={styles.cardLogo} />
                    <span className={styles.cardTeamName} title={team2.name}>{team2.name}</span>
                </div>
            </div>
            <div className={styles.cardFoot}>{foot}</div>
        </Link>
    );
};

export default LiveMatchGrid;
